import { render, staticRenderFns } from "./Teaching.vue?vue&type=template&id=683d4f5a&scoped=true"
import script from "./Teaching.vue?vue&type=script&lang=js"
export * from "./Teaching.vue?vue&type=script&lang=js"
import style0 from "./Teaching.vue?vue&type=style&index=0&id=683d4f5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "683d4f5a",
  null
  
)

export default component.exports